import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTrackClickedVideoSpeedButton } from "@air/analytics";
import { memo } from "react";
import { PlayPauseButton } from "~/components/AssetModalV2/Content/Footer/components/PlayPauseButton";
import { VolumeControl } from "~/components/AssetModalV2/Content/Footer/components/VolumeControl";
import { useVideoContentControlsContext } from "~/components/AssetModalV2/Content/VideoContentControlsContextProvider";
import { PlaybackSpeedOptions } from "~/components/AssetModalV2/Visualizer/VideoVisualizer/VideoVisualizerInner/components/PlaybackSpeedOptions";
export const PublicVideoControls = /*#__PURE__*/ memo(()=>{
    const { volume, muted, toggleMuted, onVolumeChange, isPlaying, isRewinding, play, pause, currentPlaybackSpeed, setCurrentPlaybackSpeed } = useVideoContentControlsContext();
    const { trackClickedVideoSpeedButton } = useTrackClickedVideoSpeedButton();
    const onSelectPlaybackSpeed = (speed)=>{
        setCurrentPlaybackSpeed(speed);
        trackClickedVideoSpeedButton();
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ _jsx(PlayPauseButton, {
                isPlaying: isPlaying || isRewinding,
                onPlayPause: isPlaying ? pause : play
            }),
            /*#__PURE__*/ _jsx(VolumeControl, {
                volume: volume,
                muted: muted,
                toggleMuted: toggleMuted,
                onVolumeChange: onVolumeChange,
                container: null
            }),
            /*#__PURE__*/ _jsx(PlaybackSpeedOptions, {
                currentPlaybackSpeed: currentPlaybackSpeed,
                onSelectPlaybackSpeed: onSelectPlaybackSpeed
            })
        ]
    });
});
PublicVideoControls.displayName = "PublicVideoControls";
